<template>
  <div v-if="blog">
    <div class="bg-primary-light pb-8 relative">
      <div class="circle-right hidden lg:block absolute right-0 z-20">
        <img src="~/assets/img/shapes/circle-drk-red.svg">
      </div>
      <SlimHeaderCharacter class="z-30"/>

      <div class="container content-container relative z-40 pt-8">
        <button class="w-auto inline-block btn btn-transparent text-sm mb-8 md:mb-3" @click="previousPage">
          <font-awesome-icon :icon="['fas', 'chevron-left']" size="sm" class="mr-2"/>
          Terug
        </button>

        <main class="flex flex-wrap lg:flex-no-wrap justify-center lg:justify-start">
          <aside class="relative z-30 w-full md:w-auto pt-6 lg:pt-0 lg:mr-4">
            <blog-author :image="blog.active_image ? blog.active_image.url : null" :author="blog.auteur"/>
          </aside>

          <div class="circle-left hidden lg:block absolute z-20">
            <img src="~/assets/img/shapes/circle-light-red.svg">
          </div>

          <section class="order-first lg:order-last w-full xl:w-1/2 flex-wrap">
            <header class="w-content mt-4 mb-3 pb-1 pr-8 border-b-2 border-secondary-lighter">
              <h2 class="text-primary md:text-white">
                {{ blog.title }}
              </h2>
            </header>

            <main class="w-full">
              <header
                v-if="blog.header_tekst"
                class="prose max-w-full content pt-4 md:pt-10 lg:pt-16 pb-6 lg:pb-12 h2 font-light"
                v-html="blog.header_tekst"
              />

              <section class="prose max-w-full main-content lg:pb-6" v-html="blog.tekst"/>

              <a v-if="blog.button_link" class="flex pt-4 justify-center" :href="blog.button_link">
                <button class="btn btn-secondary">
                  {{ blog.button_tekst }}
                </button>
              </a>
            </main>
          </section>
        </main>
      </div>
    </div>

    <blog-comments :comments="blog.reacties"/>
  </div>
</template>

<script>
import SlimHeaderCharacter from '~/components/headers/SlimHeaderCharacter';
import BlogAuthor from '~/components/blog/BlogAuthor';
import BlogComments from '~/components/blog/BlogComments';
import blog from '~/graphql/queries/blog';

export default {
  components: {BlogComments, BlogAuthor, SlimHeaderCharacter},
  apollo: {
    blog: {
      query: blog,
      prefetch: ({route}) => ({slug: route.params.slug}),
      variables() {
        return {
          slug: this.$route.params.slug,
        };
      },
    },
  },
  data: () => ({
    blog: {},
  }),
  methods: {
    previousPage() {
      this.$router.back();
    },
  },
  head() {
    const title = this.blog.seo?.meta_title ? this.blog.seo.meta_title : this.blog.title;

    return {
      title,
      meta: [
        this.blog.seo?.meta_description
          ? {
            hid: 'description',
            name: 'description',
            content: this.blog.seo.meta_description,
          }
          : {},
        this.blog.seo?.meta_index !== undefined
          ? {
            hid: 'robots',
            name: 'robots',
            content: (this.blog.seo.meta_follow ? 'follow ' : 'nofollow ') + (this.blog.seo.meta_index ? 'index' : 'noindex'),
          }
          : {},
        {
          hid: 'og:title',
          name: 'og:title',
          content: title,
        },
        this.blog.seo?.meta_description
          ? {
            hid: 'og:description',
            name: 'og:description',
            content: this.blog.seo.meta_description,
          }
          : {},
        this.blog.active_image
          ? {
            hid: 'og:image',
            name: 'og:image',
            content: this.blog.active_image.url,
          }
          : {},
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.circle-right {
  top: 90px;
}

.circle-left {
  left: -8%;
  top: 25%;
}

.content-container {
  margin-top: -90px;
  @screen md {
    margin-top: -150px; // overlay header
  }
  .main-content {
    column-count: 1;
    @screen lg {
      column-count: 2;
      column-gap: 2rem;
    }
  }
}
</style>
